module.exports = __webpack_public_path__ + "static/Group-0f4b61f84bf065e8184bdb737d4104a8.png";